export default {
  title: {
    id: 'asp_action_bar_actions_list_step_title',
    defaultMessage: 'What would you like to do?',
  },
  otherActionsLink: {
    id: 'asp_seller_action_bar_actions_list_step_other_actions_cta',
    defaultMessage: 'Other actions',
  },
  otherActionsTitle: {
    id: 'asp_action_bar_other_actions_step_title',
    defaultMessage: 'Other actions',
  },
  damagedPackagePendingValidationTitle: {
    id: 'asp_action_bar_actions_list_step_title_damaged_package_request_sent',
    defaultMessage: 'Damaged package and item in transit request sent to agent',
  },
  outOfWarrantyPendingValidationTitle: {
    id: 'asp_action_bar_actions_list_step_title_out_of_warranty_request_sent',
    defaultMessage: 'Out-of-warranty request sent to agent',
  },
  itemNotReceivedPendingValidationTitle: {
    id: 'asp_action_bar_actions_list_step_title_item_not_received_request_sent',
    defaultMessage: 'Item-not-received request sent to agent',
  },
  pendingValidationSubtitle: {
    id: 'asp_action_bar_actions_list_step_subtitle_problem_reported',
    defaultMessage:
      'Please wait for the agent to confirm your request. In the meantime, you can take one of the following actions.',
  },
  cannotSendMessageBannerTitle: {
    id: 'bo_sellers.customer_care.request.action_bar.cannot_send_message_banner_title',
    defaultMessage: 'This Help Request is expired | No message can be sent',
  },
  cannotSendMessageBannerContent: {
    id: 'bo_sellers.customer_care.request.action_bar.cannot_send_message_banner_content',
    defaultMessage:
      'If you need to send a new message to this conversation, you must go to your Orders > Search for the order number > Click on the three-dots option > Select Fix order issue > Other, in order to contact the agent. You can also raise an SSC ticket if needed.',
  },
}
